import { useState } from "react";
import { Requirement } from "../../types/requirement.response";
import { AddableCourse, CourseLite, CourseSummary } from "../../types/course.response";
import { CourseRequirementOverride } from "../../services/api/user-courses.api";
import { getNodeRuleDescriptor } from "../../utils/requirementResponseUtils";
import ChevronIcon from "../icons/ChevronIcon";
import HeaderCompletedCourses from "./HeaderCompletedCourses";
import { PanelNode } from "./panelUtils";

interface PanelProgressProps {
    requirement: Requirement;
    coursesMap: Record<string, CourseSummary>;
    node: PanelNode;
    nodeFulfilled: boolean;
    onAdd: (course: AddableCourse, nodeId: string | null) => void | Promise<void>;
    onDelete: (course: CourseLite) => void | Promise<void>;
    onOverride: (course: CourseLite, override: CourseRequirementOverride) => void | Promise<void>;
}

/**
 * 单个 option 面板的规则说明 + "completed/required" 展开按钮(展开看已修课程槽位)。
 * 调用方用 key={node.id} 让切 tab 时 showCompleted 自动重置。
 */
export default function PanelProgress({ requirement, coursesMap, node, nodeFulfilled, onAdd, onDelete, onOverride }: PanelProgressProps) {
    const [showCompleted, setShowCompleted] = useState(false);

    const required = node.rule.atLeastUnitsCount;
    const label = node.rule.unitsType === "CREDIT" ? "credits" : "completed";
    const descriptor = nodeFulfilled ? null : getNodeRuleDescriptor(node, coursesMap);

    if (!descriptor && required == null) return null;

    return (
        <>
            <div className="mt-2 flex items-center justify-between gap-2">
                <p className="text-xs md:text-sm text-gray-400">{descriptor}</p>
                {required != null && (
                    <button
                        className="flex items-center gap-2 transition-colors text-xs md:text-sm font-medium text-gray-500 hover:text-gray-700 whitespace-nowrap"
                        onClick={() => setShowCompleted(prev => !prev)}
                    >
                        <span>{node.summary.completedUnitsCount} / {required} {label}</span>
                        <ChevronIcon direction={showCompleted ? "up" : "down"} className="w-4 h-4" />
                    </button>
                )}
            </div>
            {showCompleted && required != null && (
                <HeaderCompletedCourses
                    requirement={requirement}
                    coursesMap={coursesMap}
                    node={node}
                    onAdd={onAdd}
                    onDelete={onDelete}
                    onOverride={onOverride}
                />
            )}
        </>
    );
}
